import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import UsaFlag from './assets/us-flag.png'; // Import flag icons
import BgFlag from './assets/bg-flag.png';

function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('selectedLanguage'));

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
        setSelectedLanguage(language);
        localStorage.setItem('selectedLanguage', language);
        window.location.reload(); // Reload the page to apply language changes
    };

    return (
        <div>
            <img
                src={UsaFlag}
                alt="USA Flag"
                onClick={() => changeLanguage('en')}
                style={{ cursor: 'pointer', width: '40px', height: 'auto', opacity: selectedLanguage === 'en' ? 1 : 0.5 }}
            />
            <img
                src={BgFlag}
                alt="BG Flag"
                onClick={() => changeLanguage('bg')}
                style={{ cursor: 'pointer', width: '40px', height: 'auto', opacity: selectedLanguage === 'bg' ? 1 : 0.5 }}
            />
            {/* Add flags for other languages if needed */}
        </div>
    );
}

export default LanguageSwitcher;
